import * as React from "react";

const { Component } = React;

import * as ClientStore from "./ClientStore";
import { Input } from "reactstrap";

interface CreateClientProps {
    organization: string;
}

interface CreateClientState {
    client: {
        id: string;
        name: string;
        redirectUri: string;
        postLogoutRedirectUri: string;
        backChannelLogoutUri: string;
        grantType: string;
        organization: string;
        secrets?: any;
    };
    isLoaded: boolean;
    isError: boolean;
    error?: any;
}

export default class CreateClient extends Component<CreateClientProps, CreateClientState> {
    constructor(props) {
        super(props);
        this.state = {
            client: {
                id: undefined,
                name: undefined,
                redirectUri: undefined,
                postLogoutRedirectUri: undefined,
                backChannelLogoutUri: undefined,
                grantType: undefined,
                organization: props.organization,
                secrets: undefined,
            },
            isLoaded: false,
            isError: false,
        };
    }

    error = (message) => {
        this.setState({
            isError: true,
            error: {
                message,
            },
        });
    };

    clearError = () => {
        this.setState({
            isError: false,
            error: {
                message: "",
            },
        });
    };

    createClient = () => {
        if (!this.state.client.name) {
            this.error("Specify a client name");
            return;
        }

        if (!this.state.client.grantType) {
            this.error("Choose a grant type");
            return;
        }

        this.clearError();

        ClientStore.CreateClient(this.state.client).then(
            (result) => {
                this.setState({
                    isLoaded: true,
                    client: result.data.client,
                });
            },
            (error) => {
                this.setState({
                    isError: true,
                    error,
                });
            }
        );
    };

    handleNameChange = (e) => {
        var name = e.target.value.trim();

        this.setState((prevState) => {
            prevState.client.name = name;

            return prevState;
        });
    };

    handleRedirectUriChange = (e) => {
        var name = e.target.value.trim();

        this.setState((prevState) => {
            prevState.client.redirectUri = name;

            return prevState;
        });
    };

    handlePostLogoutRedirectUriChange = (e) => {
        var name = e.target.value.trim();

        this.setState((prevState) => {
            prevState.client.postLogoutRedirectUri = name;

            return prevState;
        });
    };

    handleBackChannelLogoutUriChange = (e) => {
        var name = e.target.value.trim();

        this.setState((prevState) => {
            prevState.client.backChannelLogoutUri = name;

            return prevState;
        });
    };

    handleGrantTypeChange = (e) => {
        var name = e.target.value.trim();

        this.setState((prevState) => {
            prevState.client.grantType = name;

            return prevState;
        });
    };

    render() {
        return (
            <div>
                <div className="form-group row">
                    <label className="col-sm-3 col-form-label">
                        Name <span className="text-danger">*</span>
                    </label>
                    <div className="col-sm-9 pl-0">
                        <input type="text" className="form-control" onChange={this.handleNameChange} />
                    </div>
                </div>

                <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Redirect Uri</label>
                    <div className="col-sm-9 pl-0">
                        <input type="text" className="form-control" onChange={this.handleRedirectUriChange} />
                    </div>
                </div>

                <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Post Logout Redirect Uri</label>
                    <div className="col-sm-9 pl-0">
                        <input type="text" className="form-control" onChange={this.handlePostLogoutRedirectUriChange} />
                    </div>
                </div>

                <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Back Channel Logout Uri</label>
                    <div className="col-sm-9 pl-0">
                        <input type="text" className="form-control" onChange={this.handleBackChannelLogoutUriChange} />
                    </div>
                </div>

                <div className="form-group row">
                    <label className="col-sm-3 col-form-label">
                        Grant Type <span className="text-danger">*</span>
                    </label>
                    <div className="col-sm-9 pl-0">
                        <Input type="select" onChange={this.handleGrantTypeChange} defaultValue="">
                            <option value="">- Choose One -</option>

                            <option value="implicit">Implicit (Web no server interaction)</option>
                            <option value="hybrid">Hybrid (Web with server interaction)</option>
                            <option value="client_credentials">Client Credentials (No user interaction)</option>
                            <option value="urn:ietf:params:oauth:grant-type:device_code">Device </option>
                        </Input>
                    </div>
                </div>
                <div className="d-flex align-items-end flex-column h-100">
                    <div className="mb-1">
                        <button className="btn btn-primary float-right" onClick={this.createClient}>
                            Create
                        </button>
                    </div>
                </div>
                {this.state.isLoaded && (
                    <div>
                        <div className="form-group row">
                            <label className="col-sm-3 col-form-label">ID</label>
                            <div className="col-sm-9 p-2">{this.state.client.id}</div>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Name</label>
                            <div className="col-sm-9 p-2">{this.state.client.name}</div>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Secret</label>
                            <div className="col-sm-9 p-2">
                                <code>{this.state.client.secrets && this.state.client.secrets[0].value}</code>
                            </div>
                        </div>
                    </div>
                )}

                {this.state.isError && (
                    <div>
                        <div className="alert alert-warning">{this.state.error.message}</div>
                    </div>
                )}
            </div>
        );
    }
}
